import React, { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

/* Small install-prompt banner. Renders only when:
   - The browser fires beforeinstallprompt (Chrome/Edge/Android), OR
   - We detect iOS Safari (which needs manual Share → Add to Home Screen).
   Dismissal is remembered in localStorage. */
const KEY = "adn-pwa-install-dismissed";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [showIos, setShowIos] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(KEY);
    // Already installed?
    if (window.matchMedia?.("(display-mode: standalone)").matches ||
        window.navigator.standalone === true) return;
    if (dismissed) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    // iOS detection — Safari never fires beforeinstallprompt
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent) && !/crios|fxios/i.test(navigator.userAgent);
    if (isIos) {
      setShowIos(true);
      setVisible(true);
    }
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!visible) return null;

  const dismiss = () => { localStorage.setItem(KEY, "1"); setVisible(false); };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setVisible(false);
    else localStorage.setItem(KEY, "1");
    setDeferred(null);
  };

  return (
    <div data-testid="pwa-install-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-50">
      <div className="adn-card p-4 flex items-start gap-3 shadow-2xl">
        <div className="w-10 h-10 rounded bg-primary/15 text-primary flex items-center justify-center shrink-0">
          <Download size={18}/>
        </div>
        <div className="flex-1">
          <div className="font-bebas text-xl">INSTALL ADN FANFEST</div>
          {showIos ? (
            <p className="text-white/70 text-xs mt-1">
              Tap <Share size={12} className="inline mx-1"/> then <b>Add to Home Screen</b> to install on your iPhone.
            </p>
          ) : (
            <p className="text-white/70 text-xs mt-1">
              Add ADN FanFest to your home screen for one-tap check-ins and prize alerts.
            </p>
          )}
          {!showIos && (
            <button onClick={install}
              data-testid="pwa-install-btn"
              className="mt-3 px-4 py-2 bg-primary text-black font-semibold rounded text-sm">
              Install app
            </button>
          )}
        </div>
        <button onClick={dismiss} data-testid="pwa-install-dismiss"
          className="text-white/50 hover:text-white shrink-0"><X size={16}/></button>
      </div>
    </div>
  );
}
